export enum CoursePriceType {
  ProductsCost = 'ProductsCost',
  VariablePackage = 'VariablePackage',
}
